function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 511.94 511.94",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.62 107.584c-16.911 0-30.12 13.605-30.12 30v250.27c0 16.57 13.43 30 30 30h282.77M474.31 107.584c16.958 0 30.13 13.637 30.13 30v250.27c0 16.57-13.43 30-30 30h-73.97",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#81A63D",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.61 161.854v195.88c0 16.57 13.43 30 30 30h245.25M474.32 161.854v195.88c0 16.57-13.43 30-30 30h-51.05",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#81A63D",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.55 73.484c-29.89 4.44-47.58 17.27-47.58 17.27S210 57.394 141.04 79.634c-41.65 13.44-70.72 14.7-87.21 13.59-8.86-.593-16.22 6.289-16.22 14.74v246.87s34.48 11.12 103.43-11.12c68.96-22.24 114.93 11.12 114.93 11.12 8.49-6.128 27.103-14.269 47.79-17.3M386.87 348.454c23.067 6.25 65.238 13.539 87.45 6.38v-192.98l-.01-54.27c-.21-8.34-7.55-14.94-16.21-14.36-14.72.99-39.48.09-74.27-9.68",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#81A63D",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383.97 150.844.63.18c19.064 5.314 39.742 9.208 59.61 9.73M383.97 196.024c.39.11.77.22 1.15.33 18.869 5.216 39.357 9.062 59.09 9.58M444.21 251.104c-19.876-.641-39.064-4.068-58.57-9.44-.55-.15-1.11-.3-1.67-.46M383.97 286.384c.74.2 1.47.41 2.19.6 18.688 5.098 38.846 8.818 58.05 9.3M255.966 94.967v287.238",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#81A63D",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m386.669 452.304-12.888-12.257c-4.424-4.207-10.64-4.207-15.063 0l-11.201 10.652c-8.124 7.726-18.001 1.321-21.572-10.501-15.898-62.585-24.803-92.986-24.803-152.922V86.441c0-16.569 11.061-30 24.706-30h31.197c13.645 0 26.92 13.431 26.92 30v202.183c0 55.669 5.195 88.384 19.728 141.182l2.861 10.393c0 12.671-11.761 19.831-19.885 12.105zM225.848 144.55c-20.17-5.833-49.47-9.037-84.805 2.36-31.745 10.239-56.182 13.408-73.313 13.845M225.848 189.726c-20.17-5.833-49.47-9.037-84.805 2.36-31.745 10.239-56.182 13.408-73.313 13.845M225.848 234.903c-20.17-5.833-49.47-9.037-84.805 2.36-31.745 10.239-56.182 13.408-73.313 13.845M225.848 280.079c-20.17-5.833-49.47-9.037-84.805 2.36-31.745 10.239-56.182 13.408-73.313 13.845",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#81A63D",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookList);
export default __webpack_public_path__ + "static/media/book-list.ebd58e9a08e38148126fc6c8ac55c4e5.svg";
export { ForwardRef as ReactComponent };